import { memo, useEffect, useState, useCallback } from 'react';
import { Container, Col, Row, Dropdown } from 'react-bootstrap';
import { BzHeading, BzTabs, BzTab, BzDropdown } from '../../../components';
import { getLivePulse } from '../../../redux/actions/livePulse';
import { useDispatch, useSelector } from 'react-redux';
import { ALL_INDICES_SECTORS, DASHBOARD_EXPLORE_CATEGORY } from '../../../utils/global_variables';
import LivePulseCard from './LivePulseCard';
import { AutoSizer, CellMeasurer, CellMeasurerCache, Grid } from 'react-virtualized';
import ZeroStates from '../../ZeroStates';
import { handleModalData } from '../../../redux/actions/modals';
import { getTabs } from '../../../controllers/livePulse';
import LivePulseGrid from './LivePulseGrid';


const LivePulse = (props) => {

    const { setNActiveCategory, nActiveCategory, setActiveNav } = props; //AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view

    const arrLivePulse = useSelector(state => state?.livePulse);

    const { exchanges: allExchanges = [] } = useSelector(state => state?.auth?.objLoginSession?.data);

    const dispatch = useDispatch();
    const [modifiedData, setModifiedData] = useState([]);
    // Vinit Raut : 09-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
    const [updatedMktSegmentID, setUpdatedMktSegmentID] = useState(null);
    const [exchangeState, setExchangeState] = useState(null);
    // Vinit Raut : 09-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End
    //AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---Start
    const [indexSector, setIndicesSector] = useState(ALL_INDICES_SECTORS);
    //AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---End
    const [livePulseTab, setLivePulseTab] = useState(null);
    // Vinit Raut : 17-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
    const modalInfo = useSelector(state => state.modals?.modalData);
    // Vinit Raut : 17-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End

    const cache = new CellMeasurerCache({
        fixedHeight: false,
        columnWidth: 10
    });


    // Vinit Raut - 19/02/2024  - BT-107438 Breeze - Dashboard - Live Pulse - Start
    const handleExpandCollapse = useCallback(() => {
        dispatch(handleModalData({ nMappedCashinfo: livePulseTab, nMappedExchange: exchangeState }));
        setNActiveCategory(DASHBOARD_EXPLORE_CATEGORY.LIVEPULSE);
    }, [livePulseTab, exchangeState, dispatch]);
    // Vinit Raut - 19/02/2024  - BT-107438 Breeze - Dashboard - Live Pulse - End

    const getCardWidth = () => {
        if (window.matchMedia('screen and (max-width:1920px) and (min-width:1601px)').matches) {
            // The Card wWidth is Actual Card width + Margin
            return 310;
        }
        else if (window.matchMedia('screen and (max-width:1600px) and (min-width:1367px)').matches) {
            return 290;
        } else if (window.matchMedia('screen and (max-width:1366px) and (min-width:1281px)').matches) {
            return 280;
        } else if (window.matchMedia('screen and (max-width:1280px) and (min-width:1024px)').matches) {
            return 270;
        } else {
            return 260;
        }
    };

    const updateMktSegentId = useCallback((obj) => {
        setLivePulseTab(obj);
        setUpdatedMktSegmentID(obj?.exchanges.find(ex => ex.exchName === exchangeState)?.mktSgmtId);     // Parshva Shah - 07/11/2023  - BT-107438 Breeze - Dashboard - Live Pulse (added "?")
        //AzeemKhan : 07-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---Start
        setIndicesSector(ALL_INDICES_SECTORS);
        //AzeemKhan : 07-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---End
    }, [exchangeState]);

    //AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---Start
    const handleLivePulseTabChange = (data) => {
        setExchangeState(data.exchanges[0].exchName);
        setLivePulseTab(data);
        setIndicesSector(ALL_INDICES_SECTORS);
    };
    //AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---End

    // Vinit Raut - 19/02/2024  - BT-107438 Breeze - Dashboard - Live Pulse - Start
    useEffect(() => {
        if (!exchangeState && modifiedData?.length && livePulseTab) {
            if (modalInfo?.nMappedExchange) {
                setExchangeState(modalInfo?.nMappedExchange);
            } else {
                setExchangeState(modifiedData[modifiedData?.findIndex(md => md.id === livePulseTab.id)]?.exchanges[0]?.exchName);
            }
        }
    }, [exchangeState, livePulseTab, modifiedData, modalInfo?.nMappedExchange]);
    // Vinit Raut - 19/02/2024  - BT-107438 Breeze - Dashboard - Live Pulse - End

    useEffect(() => {
        if (updatedMktSegmentID) {
            dispatch(getLivePulse({ nMarketSegmentId: updatedMktSegmentID, indexSector: indexSector }));//AzeemKhan : 07-11-2023 : BT-108797 -  Breeze - Live pulse expanded view :dynamic api call
        }
    }, [dispatch, updatedMktSegmentID, indexSector]);

    useEffect(() => {
        if (livePulseTab && exchangeState) {
            updateMktSegentId(livePulseTab);
        }
    }, [exchangeState, livePulseTab, updateMktSegentId]);

    useEffect(() => {
        if (modifiedData.length === 0 && allExchanges?.length > 0) {
            let tabs = getTabs(allExchanges);
            setModifiedData(tabs);
            // Vinit Raut : 17-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
            updateMktSegentId(tabs?.find(tab => tab.name === modalInfo?.nMappedCashinfo?.name) ?? tabs[0]);
            // Vinit Raut : 17-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End
        }
    }, [allExchanges, modifiedData, updateMktSegentId]);

    return (
        <>
            {nActiveCategory === DASHBOARD_EXPLORE_CATEGORY.LIVEPULSE ?
                <LivePulseGrid setNActiveCategory={setNActiveCategory} setActiveNav={setActiveNav} setLivePulseTab={setLivePulseTab} setExchangeState={setExchangeState} modifiedData={modifiedData} livePulseTab={livePulseTab} exchangeState={exchangeState} indexSector={indexSector} setIndicesSector={setIndicesSector} handleLivePulseTabChange={handleLivePulseTabChange} updatedMktSegmentID={updatedMktSegmentID} />
                :
                //AzeemKhan : 07-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---End
                <Container fluid className='p-0 px-4 pt-4 pb-5 live-pulse-card-wrapper position-relative'>
                    <div className='icon-100 icon-live-pulse-background'>&nbsp;</div>
                    <Row className='g-0 mb-3 row-cols-3 align-items-center'>
                        <Col data-testid="livepulse-heading" md='auto' className='d-inline-flex align-items-center gap-2'>
                            <div className='icon-24 icon-live-pulse d-inline-block flex-shrink-0'></div>
                            <div className='font-medium font-size5 color-active-text line-height-1 text-uppercase d-inline-block'>Live Pulse</div>
                        </Col>
                        <Col className='flex-grow-1'>
                            <div className='horizontal-scroll-wrap d-flex justify-content-center text-center'>
                                <BzTabs className='nav nav-tabs-light'>
                                    {modifiedData?.length && modifiedData?.map(data => {
                                        return <>
                                            <BzTab data-testid={`livepulse-${data?.name}-tab`} className='nav-link text-capitalize' tabKey={data.id.toString()} isActive={livePulseTab.id === data.id} onClick={() => {
                                                setExchangeState(data.exchanges[0].exchName);
                                                setLivePulseTab(data);
                                            }}>{data.name}</BzTab>
                                        </>;
                                    })}
                                </BzTabs>
                            </div>
                        </Col>
                        <Col md='auto' className='d-flex justify-content-end align-items-center gap-2'>
                            <div className='Bzselect-dropdown'>
                                <BzDropdown>
                                    <Dropdown.Toggle data-testid='livepulse-exch-dropdown-toggle' className='btn-default'>{exchangeState}</Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {
                                            modifiedData?.length && modifiedData[modifiedData?.findIndex(md => md.id === livePulseTab.id)]?.exchanges?.map(data => (
                                                <Dropdown.Item data-testid={`livepulse-exchange-dropdown-${data?.exchName}-item`} onClick={() => { setExchangeState(data?.exchName); }}>{data.exchName}</Dropdown.Item>
                                            ))
                                        }
                                    </Dropdown.Menu>
                                </BzDropdown>
                            </div>
                            <div data-testid='livepulse-expand-icon' className='background-icon' onClick={handleExpandCollapse}>
                                <div className='icon-16 icon-expand icon-dark'></div>
                            </div>
                        </Col>
                    </Row>
                    {
                        arrLivePulse?.arrLivePulse?.length > 0 ?
                            <div className='live-pulse-card-wrap'>
                                <AutoSizer>
                                    {
                                        ({ width, height }) => {
                                            return (
                                                <Grid
                                                    cellRenderer={({ columnIndex, key, rowIndex, style, parent }) => {
                                                        return (
                                                            <CellMeasurer
                                                                key={key}
                                                                cache={cache}
                                                                parent={parent}
                                                                columnIndex={columnIndex}
                                                                rowIndex={rowIndex}
                                                            >
                                                                {/* // Parshva Shah - 07/11/2023  - BT-107438 Breeze - Dashboard - Live Pulse - Start */}
                                                                <LivePulseCard style={style} tabId={livePulseTab?.id} eachItem={arrLivePulse?.arrLivePulse[columnIndex]} id={columnIndex} exchangeState={exchangeState} />
                                                                {/* // Parshva Shah - 07/11/2023  - BT-107438 Breeze - Dashboard - Live Pulse - End */}
                                                            </CellMeasurer>
                                                        );
                                                    }}
                                                    columnCount={arrLivePulse?.arrLivePulse?.length || 6}
                                                    columnWidth={getCardWidth}
                                                    height={height}
                                                    rowCount={1}
                                                    rowHeight={175}
                                                    width={width}
                                                />

                                            );
                                        }
                                    }
                                </AutoSizer>
                            </div>
                            :
                            <div className='zero-state-alerts zero-state-alerts-lg'>
                                <ZeroStates subText="Currenty there is no Live Pulse Scrips" icon='icon-64 icon-nodata mb-3 mrgauto' />
                            </div>
                    }
                </Container>}
        </>
    );
};
export default memo(LivePulse);